export default "__VITE_ASSET__Cjszgypq__"